import { useEffect, useState } from 'react';
import { COMMERCIAL_CATALOGS_CHANGED_EVENT } from '../components/placeholders/commercialCatalogDefaults';
import { PRODUCTION_CATALOGS_CHANGED_EVENT } from '../components/placeholders/productionCatalogDefaults';

/**
 * Re-render when Comercial/Producción → Ajustes catalogs change (localStorage).
 * Use the returned tick as a dependency for getters that read those catalogs.
 */
export const useCommercialCatalogRefresh = () => {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const onChange = () => setTick((value) => value + 1);
    window.addEventListener(COMMERCIAL_CATALOGS_CHANGED_EVENT, onChange);
    window.addEventListener(PRODUCTION_CATALOGS_CHANGED_EVENT, onChange);
    window.addEventListener('storage', onChange);
    return () => {
      window.removeEventListener(COMMERCIAL_CATALOGS_CHANGED_EVENT, onChange);
      window.removeEventListener(PRODUCTION_CATALOGS_CHANGED_EVENT, onChange);
      window.removeEventListener('storage', onChange);
    };
  }, []);

  return tick;
};

export default useCommercialCatalogRefresh;
